import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const TaskLayout = () => {
  const navList = useNav();
  let {taskBottomNav, topTaskNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={taskBottomNav} topTabs={topTaskNav} />
      <Outlet />
    </div>
  );
};

export default TaskLayout;
